import { getAPI } from "../../../../api/Networking";
import dayjs from "dayjs";
import { OpsSyncAnalyticsAPIFilters } from "../../../../models/Dashboard/OpsSyncAnalyticsFilters";
import { OpsSyncAnalyticsData } from "../../../../models/Dashboard/OpsSyncAnalyticsData";

export default class OpsSyncAnalyticsDashboardAPI {
  getData = async (
    url: string,
    filters: OpsSyncAnalyticsAPIFilters
  ): Promise<OpsSyncAnalyticsData[]> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.order_type && filters.order_type.length > 0) {
        queryParams.append(
          "order_type",
          filters.order_type.map((item) => item.id).join(",")
        );
      }

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }

      if (filters.archived) {
        queryParams.append(
          "archived",
          filters.archived.value.toLowerCase() === "archived" ? "true" : "false"
        );
      }

      if (filters.sales_admin_id && filters.sales_admin_id.length > 0) {
        queryParams.append(
          "sales_poc_id",
          filters.sales_admin_id.map((item) => item.id).join(",")
        );
      }

      if (filters.pm_admin_id && filters.pm_admin_id.length > 0) {
        queryParams.append(
          "pm_admin_id",
          filters.pm_admin_id.map((item) => item.id).join(",")
        );
      }

      if(filters.product_ids && filters.product_ids.length > 0) {
        queryParams.append(
          "product_ids",
          filters.product_ids.map((item) => item.id).join(",")
        );
      }
      
      if(filters.customer_ids && filters.customer_ids.length > 0) {
        queryParams.append(
          "customer_ids",
          filters.customer_ids.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/ops-analytics/${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
